(() => {
  "use strict";

  var e = {
      8213: e => {
        e.exports = require("@babel/runtime/helpers/extends");
      },
      353: e => {
        e.exports = require("@babel/runtime/helpers/slicedToArray");
      },
      4702: e => {
        e.exports = require("@babel/runtime/helpers/taggedTemplateLiteral");
      },
      6958: e => {
        e.exports = require("@babel/runtime/helpers/toConsumableArray");
      },
      6689: e => {
        e.exports = require("react");
      },
      7518: e => {
        e.exports = require("styled-components");
      }
    },
    t = {};
  function r(n) {
    var o = t[n];
    if (void 0 !== o) return o.exports;
    var a = t[n] = {
      exports: {}
    };
    return e[n](a, a.exports, r), a.exports;
  }
  r.n = e => {
    var t = e && e.__esModule ? () => e.default : () => e;
    return r.d(t, {
      a: t
    }), t;
  }, r.d = (e, t) => {
    for (var n in t) r.o(t, n) && !r.o(e, n) && Object.defineProperty(e, n, {
      enumerable: !0,
      get: t[n]
    });
  }, r.o = (e, t) => Object.prototype.hasOwnProperty.call(e, t), r.r = e => {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(e, "__esModule", {
      value: !0
    });
  };
  var n = {};
  (() => {
    r.r(n), r.d(n, {
      default: () => v
    });
    var e,
      t,
      o = r(8213),
      a = r.n(o),
      l = r(6958),
      i = r.n(l),
      u = r(353),
      d = r.n(u),
      s = r(4702),
      p = r.n(s),
      c = r(6689),
      f = r.n(c),
      b = r(7518),
      m = r.n(b),
      x = m().ul(e || (e = p()(["\n  width: 100%;\n  list-style: none;\n  padding: 0;\n  margin: 0;\n"]))),
      y = m().li(t || (t = p()(["\n  width: 100%;\n"])));
    const v = function (e) {
      var t = e.initiallyOpenedItem,
        r = void 0 === t ? 0 : t,
        n = e.onOpen,
        o = e.onClose,
        l = e.allowMultipleExpanded,
        u = e.allowZeroExpanded,
        s = e.accordion,
        p = e.data,
        b = e.dataTestId,
        m = (0, c.useState)(null !== r ? [r] : []),
        v = d()(m, 2),
        g = v[0],
        O = v[1],
        h = function (e) {
          return g.includes(e);
        };
      return f().createElement(x, {
        "data-testid": b
      }, p.map(function (e, t) {
        return f().createElement(y, {
          key: t
        }, f().createElement(s, a()({
          isOpenExternal: h(t),
          toggleExternal: function () {
            return function (e) {
              h(e) ? (g.length > 1 || u) && (O(g.filter(function (t) {
                return t !== e;
              })), o && o(e)) : (O(l ? [].concat(i()(g), [e]) : [e]), n && n(e));
            }(t);
          },
          dataTestId: b && "".concat(b, "-item-").concat(t)
        }, e)));
      }));
    };
  })();
  var o = exports;
  for (var a in n) o[a] = n[a];
  n.__esModule && Object.defineProperty(o, "__esModule", {
    value: !0
  });
})();